import { render, staticRenderFns } from "./PossibleTaxIncentives.vue?vue&type=template&id=4ab40854&scoped=true"
import script from "./PossibleTaxIncentives.vue?vue&type=script&lang=js"
export * from "./PossibleTaxIncentives.vue?vue&type=script&lang=js"
import style0 from "./PossibleTaxIncentives.vue?vue&type=style&index=0&id=4ab40854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab40854",
  null
  
)

export default component.exports